import i18n from "../lang/i18n";

export const generateEventType = type => {
  switch (type) {
    case "event":
      return i18n.t("schedule.event");
    case "holiday":
      return i18n.t("schedule.holiday");
    case "activity":
      return i18n.t("schedule.activity");
    case "schedule":
      return i18n.t("schedule.class_schedule");
    case "meeting":
      return i18n.t("schedule.virtual_meeting");
  }
};

export function generateStatusReport(status) {
  switch (status) {
    case "Pending":
      return i18n.t("progress_report.pending");
    case "Not-approve":
      return i18n.t("submitted_report.reject");
    case "Official":
      return i18n.t("progress_report.official");
    case "Draft":
      return i18n.t("progress_report.draft");
  }
}

export function generateDwellingType(type) {
  switch (type) {
    case "Family residence":
      return i18n.t("dwelling_types.type_1");
    case "Foster home":
      return i18n.t("dwelling_types.type_2");
    case "Group home/halfway house":
      return i18n.t("dwelling_types.type_3");
    case "No home":
      return i18n.t("dwelling_types.type_4");
    case "Other dormitory":
      return i18n.t("dwelling_types.type_5");
    case "Residental school/dormitory":
      return i18n.t("dwelling_types.type_6"); //Residential
    case "Rooming house":
      return i18n.t("dwelling_types.type_7");
    case "Transient shelter":
      return i18n.t("dwelling_types.type_8");
    case "Boarding house":
      return i18n.t("dwelling_types.type_9");
    case "Cooperative house":
      return i18n.t("dwelling_types.type_10");
    case "Crisis shelter":
      return i18n.t("dwelling_types.type_11");
    case "Disaster shelter":
      return i18n.t("dwelling_types.type_12");
    case "Institution":
      return i18n.t("dwelling_types.type_13");
    case "Other":
      return i18n.t("dwelling_types.type_4");
  }
}

export function generateEntryReason(reason) {
  switch (reason) {
    case "Other":
      return i18n.t("entry_reasons.reason_1");
    case "Original entry into a United States school":
      return i18n.t("entry_reasons.reason_2");
    case "Original entry into a United States school from a foreign country with an interruption in schooling":
      return i18n.t("entry_reasons.reason_3");
    case "Original entry into a United States school from a foreign country with no interruption in schooling":
      return i18n.t("entry_reasons.reason_4");
    case "Re-entry after a voluntary withdrawal":
      return i18n.t("entry_reasons.reason_5");
    case "Re-entry after an involuntary withdrawal":
      return i18n.t("entry_reasons.reason_6");
    case "Re-entry from the same school with no interruption of schooling":
      return i18n.t("entry_reasons.reason_7");
    case "Transfer from a charter school":
      return i18n.t("entry_reasons.reason_8");
    case "Transfer from a private, non - religiously - affiliated school in a different local education agency in the same state":
      return i18n.t("entry_reasons.reason_9");
    case "Transfer from a private, non - religiously - affiliated school in a different state":
      return i18n.t("entry_reasons.reason_10");
    case "Transfer from a private, non - religiously - affiliated school in the same local education agency":
      return i18n.t("entry_reasons.reason_11");
    case "Transfer from a private, religiously - affiliated school in a different local education agency in the same state":
      return i18n.t("entry_reasons.reason_12");
    case "Transfer from a private, religiously - affiliated school in a different state":
      return i18n.t("entry_reasons.reason_13");
    case "Transfer from a private, religiously - affiliated school in the same local education agency":
      return i18n.t("entry_reasons.reason_14");
    case "Transfer from a public school in a different local education agency in the same state":
      return i18n.t("entry_reasons.reason_15");
    case "Transfer from a public school in a different state":
      return i18n.t("entry_reasons.reason_16");
    case "Transfer from a public school in the same local education agency":
      return i18n.t("entry_reasons.reason_17");
    case "Transfer from a school outside of the country":
      return i18n.t("entry_reasons.reason_18");
    case "Transfer from an institution":
      return i18n.t("entry_reasons.reason_19");
    case "Transfer from home schooling":
      return i18n.t("entry_reasons.reason_20");
  }
}

export const generateSex = sex => {
  switch (sex) {
    case "Male":
      return i18n.t("staff.male");
    case "Female":
      return i18n.t("staff.female");
    case "Other":
      return i18n.t("staff.other");
  }
};

export const generateRole = role => {
  switch (role) {
    case "Admin":
      return i18n.t("common.admin");
    case "Teacher":
      return i18n.t("common.teacher");
    case "Student":
      return i18n.t("common.student");
    case "Family":
      return i18n.t("common.family");
    case "Counselor":
      return i18n.t("common.counselor");
    case "Principal":
      return i18n.t("setting.principal");
  }
};

export const attendanceStatus = {
  Present: i18n.t("attendance_report.student.present"),
  "Ex.tardy": i18n.t("attendance_report.student.excused_tardy"),
  "Ex.absence": i18n.t("attendance_report.student.excused_absence"),
  "Unex.absence": i18n.t("attendance_report.student.unexcused_absence"),
  "Unex.tardy": i18n.t("attendance_report.student.unexcused_tardy")
};

export const generateStatus = status => {
  switch (status) {
    case "Present":
      return i18n.t("attendance_report.student.present");
    case "Ex.absence":
      return i18n.t("attendance_report.student.excused_absence");
    case "Unex.absence":
      return i18n.t("attendance_report.student.unexcused_absence");
    case "Ex.tardy":
      return i18n.t("attendance_report.student.excused_tardy");
    case "Unex.tardy":
      return i18n.t("attendance_report.student.unexcused_tardy");
    case "unchecked":
      return i18n.t("attendance_report.student.unchecked");
    case "Active":
      return i18n.t("common.active");
    case "Inactive":
      return i18n.t("common.inactive");
    case "withdrawal":
      return i18n.t("student.withdrawal");
    case "On-going":
      return i18n.t("common.on_going");
    case "Concluded":
      return i18n.t("common.concluded");
    case "Pending":
      return i18n.t("common.pending");
    case "assigned":
      return i18n.t("task_management.assigned");
    case "in-progress":
      return i18n.t("task_management.in_progress");
    case "done":
      return i18n.t("task_management.done");
    case "closes":
      return i18n.t("task_management.closes");
    case "re-open":
      return i18n.t("task_management.re_open");
    default:
      return "";
  }
};

export const generateTypeReport = type => {
  switch (type) {
    case "monthly_report":
      return i18n.t("submitted_report.monthly_report");
    case "mid_term":
      return i18n.t("submitted_report.mid_term");
    case "end_of_semester_report":
      return i18n.t("submitted_report.end_of_semester_report");
    case "end_of_semester_1":
      return i18n.t("submitted_report.end_of_semester_1");
    case "end_of_semester_2":
      return i18n.t("submitted_report.end_of_semester_2");
    case "default":
      return i18n.t("survey.default");
    case "honors":
      return i18n.t("subject.honors");
    case "standard":
      return i18n.t("program.standard");
    case "high_school":
      return i18n.t("program.high_school");
    case "igs-prep":
      return i18n.t("Prep");
    default:
      return "";
  }
};
